export default "__VITE_ASSET__B7vsCpI3__"